module.exports = __webpack_public_path__ + "static/media/close-menu.37124726.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close-menu.svg
// module id = 146
// module chunks = 0